import tw from "twin.macro";

// Superposición del fondo que puede variar su opacidad
export const OpacityOverlay = tw.div`z-10 bg-primary-500 opacity-25`;